import { AxiosResponse, AxiosError } from 'axios';

type AuthToken = {
  accessToken: string;
  refreshToken: string;
};

export enum Result {
  Success = 1,
  NotAuthenticated = 2,
  NoPermission = 3,
  FailedValidation = 4,
  Exception = 5,
  NotFound = 6,
  NotImplemented = -1
}

type BaseResponse = {
  generatedAt: string;
  result: Result;
  authTokens?: AuthToken;
  userMessage?: string;
  systemMessage?: string;
};

export type ApiBasicResponse<T> = BaseResponse & {
  result: Result.Success;
  response: T;
};

type ApiErrorResponse = BaseResponse & {
  result: Exclude<Result, Result.Success>;
  systemErrorMessage: string;
  systemErrorType: string;
  systemErrorStack: string;
};

export type AxiosErrorResponse = AxiosError & {
  response?: AxiosResponse<ApiErrorResponse>;
};

export type ApiError = Error & {
  resultCode?: Result;
  statusCode?: number;
};
